import axios, { AxiosError, AxiosProgressEvent } from 'axios';

export const baseURL = process.env.NEXT_PUBLIC_API_URL;

export const getUploadedPercentage = (event: AxiosProgressEvent) => {
  const { loaded, total } = event;
  return total && total > 0 ? Math.round((loaded / total) * 100) : 0;
};

export const api = axios.create({
  baseURL,
  // withCredentials: true,
});

// register request interceptors
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    config.headers['Accept-Language'] = 'en';

    return config;
  },
  async (error: Error) => {
    return await Promise.reject(error);
  },
);

// register response interceptors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: AxiosError<{ message?: string }>) => {
    const message =
      error.response?.data?.message ||
      error?.message ||
      'An error occurred, try again later';
    return Promise.reject({
      ...error,
      message,
    });
  },
);

export default api;
